import http from 'axios'

export default {
  // Thèmes
  getFaqThemes: () => {
    return http.get(`/web/v1/faq-theme`)
  },
  createFaqTheme: (faqTheme) => {
    return http.post(`/web/v1/faq-theme`, faqTheme)
  },
  updateFaqTheme: (id, faqTheme) => {
    return http.put(`/web/v1/faq-theme/${id}`, faqTheme)
  },
  deleteFaqTheme: (id) => {
    return http.delete(`/web/v1/faq-theme/${id}`)
  },

  // Questions/Reponses
  createFaqQuestionReponse: (faqQuestionReponse) => {
    return http.post(`/web/v1/faq-question-reponse`, faqQuestionReponse)
  },
  updateFaqQuestionReponse: (id, faqQuestionReponse) => {
    return http.put(`/web/v1/faq-question-reponse/${id}`, faqQuestionReponse)
  },
  deleteFaqQuestionReponse: (id) => {
    return http.delete(`/web/v1/faq-question-reponse/${id}`)
  }
}